import i18next from 'i18next';
import React from 'react';

import PreviousCurrentCell from '../../common/PreviousCurrentCell';

const sortComparator = (a, b) => a.current - b.current;

// Product table columns with comparison
export const productColumns = () => [
  {
    field: 'name',
    headerName: i18next.t('GENERAL.NAME'),
    width: 200,
    sortable: true,
    filterable: true,
  },
  {
    field: 'category',
    headerName: i18next.t('GENERAL.CATEGORY'),
    width: 150,
    sortable: true,
    filterable: true,
  },
  {
    field: 'units',
    headerName: i18next.t('ANALYSIS.PERFORMANCE.PRODUCT_UNITS_SOLD'),
    width: 180,
    sortable: true,
    sortComparator,
    renderCell: (params) => (
      <PreviousCurrentCell
        current={params.value.current}
        previous={params.value.previous}
        isClickable
      />
    ),
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'turnoverExcludingTaxes',
    headerName: i18next.t('GENERAL.TURNOVER_EX_TAX'),
    width: 180,
    sortable: true,
    sortComparator,
    renderCell: (params) => (
      <PreviousCurrentCell
        current={params.value.current}
        previous={params.value.previous}
        isClickable
        isCurrency
      />
    ),
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'mix',
    headerName: i18next.t('ANALYSIS.PERFORMANCE.MIX'),
    width: 180,
    sortable: true,
    sortComparator,
    renderCell: (params) => (
      <PreviousCurrentCell
        current={params.value.current}
        previous={params.value.previous}
        isClickable
        isPercentage
      />
    ),
    filterable: false,
    disableColumnMenu: true,
  },
];
